import { Component } from 'react';

import responsiveService from '../../../../Services/responsive';
import { SCREEN_WIDTH_SMALL, SCREEN_WIDTH_MEDIUM } from '../constants';

const withResponsive = (Composed) => {
  class ResponsiveComponent extends Component {
    static displayName = `WithResponsive${Composed.displayName || Composed.name}`;

    constructor(props) {
      super(props);

      this.state = {
        responsiveWidth: responsiveService.getCurrent(),
      };
    }

    componentDidMount() {
      this.unsubscribe = responsiveService.registerOnChangeCallback(this.handleResponsiveChange);
    }

    componentWillUnmount() {
      this.unsubscribe();
    }

    handleResponsiveChange = (responsiveWidth) => {
      this.setState(() => ({ responsiveWidth }));
    };

    render() {
      const { responsiveWidth } = this.state;
      const isMobile = [SCREEN_WIDTH_SMALL, SCREEN_WIDTH_MEDIUM].includes(responsiveWidth);

      return <Composed {...this.props} isMobile={isMobile} responsiveWidth={responsiveWidth} />;
    }
  }

  return ResponsiveComponent;
};

export default withResponsive;
